import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "v1/categories/";

export default {
  /**
   * GET /api/v1/categories
   * @param {{ Search: string, ParentId: number }} params
   * @returns {Promise}
   */
  getCategories(params) {
    return axios.get(`${RESOURCE_NAME}`, {
      params
    });
  },

  /**
   * GET /api/v1/categories?ParentId=integer
   * @param {number} ParentId
   * @returns {Promise}
   */
  getCategoriesByParentId(ParentId) {
    return axios.get(`${RESOURCE_NAME}`, {
      params: { ParentId, PageSize: 1000 },
    });
  },

  /**
   * POST /api/v1/categories
   * @param {{ParentId:number,CategoryIndex:number,CategoryName:string,CategoryIconUrl:string}} body
   * @returns {Promise}
   */
  createCategory(body) {
    return axios.post(`${RESOURCE_NAME}`, body);
  },

  /**
   * PUT /api/v1/categories
   * @param {{Id:number,ParentId:number,CategoryIndex:number,CategoryName:string,CategoryIconUrl:string}} body
   * @returns {Promise}
   */
  updateCategory(body) {
    return axios.put(`${RESOURCE_NAME}`, body);
  },

  /**
   * PUT /api/v1/categories/updatecategoryindex
   * @param {Object} body
   * @returns {Promise}
   */
  updateIndex(body) {
    return axios.put(`${RESOURCE_NAME}updatecategoryindex`, body);
  },

  /**
   * PUT /api/v1/categories/translations/update
   * @param {Object} body
   * @returns {Promise}
   */
  updateCategoryTranslations(body) {
    return axios.put(`${RESOURCE_NAME}translations/update`, body);
  },

  /**
   * DELETE /api/v1/categories/delete/{id}
   * @param {number} id
   * @returns {Promise}
   */
  deleteCategory(id) {
    return axios.delete(`${RESOURCE_NAME}delete/${id}`);
  },

  /**
   * GET /api/v1/categories
   * @param {Object} params
   * @returns {Promise}
   */
  getCategories2(params) {
    return axios.get(`${RESOURCE_NAME}`, { params });
  },

  /**
   * GET /api/v1/categories/treeview
   * @param {number} id
   * @returns {Promise}
   */
  getCategoriesInTreeView(id) {
    return axios.get(`${RESOURCE_NAME}treeview`, { params: { id } });
  },

  /**
   * GET /api/v1/categories/treeview?parentid={id}
   * @param {number} id
   * @returns {Promise}
   */
  getCategoriesInTreeView2(id) {
    return axios.get(`${RESOURCE_NAME}treeview?parentid=${id}`);
  },
};
